/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import './style/premiumFeature.scss';

import {voidFunction, WithBackground} from '@dvrd/dvr-controls';

import React, {MouseEventHandler, PureComponent} from 'react';

import {BluemateButton} from '../controls';

import Image from '../misc/image';

import i18n from '../../i18n';

interface Props {
    onProceed: MouseEventHandler;
    active: boolean;
}

export default class PremiumFeature extends PureComponent<Props> {
    render = () => {
        const {active, onProceed} = this.props;
        return (
            <WithBackground
                active={active}
                onClose={voidFunction}
                backgroundClass='premium-background'
                backgroundColor='transparent'
            >
                <div className='premium-feature'>
                    <div className='header-container'>
                        <label className='header-title'>{i18n.t('trialEnd.premiumFeature', 'Premium Feature')}</label>
                    </div>
                    <div className='body-container'>
                        <Image name='trial-rocket' className='trial-img' />
                        <label className='body-title'>
                            {i18n.t('trialEnd.continueWithBluemate', 'Doorgaan met Bluemate')}
                        </label>
                        <p className='message-container'>
                            {i18n.t(
                                'trialEnd.featureUnavailable',
                                'Deze feature is niet beschikbaar zonder abonnement.'
                            )}
                            <br />
                            {i18n.t(
                                'trialEnd.goToSettingsToStart',
                                'Ga naar de instellingen om je abonnement te starten.'
                            )}
                        </p>
                        <BluemateButton
                            onClick={onProceed}
                            label={i18n.t('trialEnd.goToSettings', 'Ga naar instellingen')}
                        />
                    </div>
                </div>
            </WithBackground>
        );
    };
}
